//C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Components\HR\Pages\Reports.jsx
import Reports from "../../Survey/Pages/Reports";
import {
    GetAssessmentReportDetails,
    GetBulkExcelReport,
    GetExcelReport,
} from "../Services/CompanyServices";

const services = {
    getAssessmentReportDetails: GetAssessmentReportDetails,
    getExcelReport: GetExcelReport,
    getBulkExcelReport: GetBulkExcelReport,
};

export default function HRReports() { return <Reports services={services} />; }
